import React from "react";
import { Fragment } from "react";
import Fade from "react-reveal/Fade";

function Corporateinfos() {
  return (
    <Fragment>
      <div className="container boxes companyDetails">
        <div className="row ArticlesAndBlogs">
          <Fade down delay={500}>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-right" data-aos-duration="4000">
                  Name of Statutory Auditor
                </h3>
                {/* <p data-aos="fade-right" data-aos-duration="4000">UHY Hassan Naeem & Co., 402, Progressive Center, Sharah-e-Faisal, Karachi, Pakistan Phone: +92 21 34322551-3 Web: www.uhy-hnco.com</p> */}
                <p data-aos="fade-right" data-aos-duration="4000">
                  Location:{" "}
                  <a
                    href="https://www.google.com/maps/place/UHY+Hassan+Naeem+%26+Co./@24.8631018,67.0741932,21z/data=!4m7!3m6!1s0x3eb33ea3c359a97d:0xb0dd0eb7042c4cde!8m2!3d24.8632639!4d67.0743981!15sCgt1aHkga2FyYWNoaZIBD2FjY291bnRpbmdfZmlybeABAA!16s%2Fg%2F11gdrdk0jw?entry=tts&g_ep=EgoyMDI0MDUwOC4wKgBIAVAD"
                    target="_blank"
                    rel="noreferrer"
                  >
                    UHY Hassan Naeem & Co., 402, Progressive Center,
                    Sharah-e-Faisal, Karachi, Pakistan
                  </a>{" "}
                  | Phone: <a href="tel:+922134322551">+92 21 34322551</a> -{" "}
                  <a href="tel:+922134322553">+92 21 3432255</a> | Web:{" "}
                  <a
                    href="https://uhy-hnco.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.uhy-hnco.com
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade down delay={700}>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-left" data-aos-duration="4000">
                  Legal Advisor
                </h3>
                <p data-aos="fade-left" data-aos-duration="4000">
                  Location:{" "}
                  <a
                    href="https://maps.app.goo.gl/J5XGZDRMziURN1SC8"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AHM & Co Address: 415, Eden Heights, Jail Road, Lahore
                  </a>{" "}
                  | Email: <a href="mailto:info@ahmco.pk">info@ahmco.pk</a> |
                  Phone: <a href="tel:04235786749">042-35786749</a> | Website:{" "}
                  <a href="http://ahmco.pk/" target="_blank" rel="noreferrer">
                    http://ahmco.pk/
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-right" data-aos-duration="4000">
                  Membership
                </h3>
                <p data-aos="fade-right" data-aos-duration="4000">
                  Insurance Association of Pakistan{" "}
                  <a href="http://iap.net.pk/" target="_blank" rel="noreferrer">
                    (IAP){" "}
                  </a>{" "}
                  & Karachi Chamber of Commerce and Industries{" "}
                  <a
                    href="https://www.kcci.com.pk/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    (KCCI)
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-left" data-aos-duration="4000">
                  Regulator of the Company
                </h3>
                <p data-aos="fade-left" data-aos-duration="4000">
                  Location:{" "}
                  <a
                    href="https://maps.app.goo.gl/RJ5JCigqyeLGSsQC9"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Securities & Exchange Commission of Pakistan Insurance
                    Division, NIC Building, 63 Jinnah Ave, Block L F 7/4 Blue
                    Area, Islamabad-44000, Pakistan
                  </a>{" "}
                  | Web link:{" "}
                  <a
                    href="https://www.secp.gov.pk/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://www.secp.gov.pk/
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-right" data-aos-duration="4000">
                  Corporate Advisor
                </h3>
                <p data-aos="fade-right" data-aos-duration="4000">
                  RS Corporate Advisory:{" "}
                  <a
                    href="https://maps.app.goo.gl/nkUWXvm2UsdFHTWw5"
                    target="_blank"
                    rel="noreferrer"
                  >
                    First Floor, Plot No.62, Central Commercial Area (CCA),
                    Block-T, Phase-2 DHA, Lahore Cantt.
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade>
            <div className="col-sm-6">
              <div className="audit">
                <h3 data-aos="fade-left" data-aos-duration="4000">
                  Share Registrar
                </h3>
                <p data-aos="fade-left" data-aos-duration="4000">
                  Location:{" "}
                  <a
                    href="https://maps.app.goo.gl/UnLSZWGcZWUCphe96"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Central Depository Company of Pakistan Limited, CDC
                    House.99-B, Block-B, S.M.C.H.S, Main Shahra-e-Faisal.
                    Karachi.
                  </a>{" "}
                  | Tel UAN:{" "}
                  <a href="tel:+9221111111500">(+92 21) 111 111 500 </a> |
                  Email: <a href="mailto:info@cdcpak.com">info@cdcpak.com</a>
                </p>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </Fragment>
  );
}

export default Corporateinfos;
